import { FormStepType } from "./types";
import { applicant_details } from "./steps/applicant-details";
import { contact_information } from "./steps/contact-information";
import { passport_details_renewal } from "./steps/passport-details-renewal";

export const form_ds_82: FormStepType[] = [
  applicant_details,
  contact_information({ additionalPhoneNumbers: 2 }),
  passport_details_renewal,
];
